import {createContext, useContext, useEffect, useState} from 'react';
import Loader from "../components/Loader/Loader";
import CmsService from "../services/CmsService";
import {ScreenHelper} from "../components/Utilities/ScreenHelper";
import {useTranslation} from "react-i18next";

const CmsContext = createContext();

export const CmsProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);

    const [landingData, setLandingData] = useState({})
    const [pickProgramData, setPickProgramData] = useState([])
    const [questionnaireData, setQuestionnaireData] = useState([])
    const [productBannersData, setProductBannersData] = useState({})
    const [localeData, setLocaleData] = useState([])
    // const [appLoading   , setAppLoading] = useState(false);
    const [renderingType, setRenderingType] = useState(ScreenHelper.initRenderingType());
    const [landingRenderingType, setLandingRenderingType] = useState(ScreenHelper.initLandingRenderingType());

    useEffect(() => {
        ScreenHelper.getRenderingType(setRenderingType);
    }, []);

    useEffect(() => {
        ScreenHelper.getLandingRenderingType(setLandingRenderingType);
    }, []);

    const { i18n } = useTranslation();

    useEffect(()=>{
        let timeoutId;
        setIsLoading(true)
        const fetchCms =  async ()=>{
            try {
                setLandingData(await CmsService.getLandingPageContent(i18n.language))
                setPickProgramData(await CmsService.getPickProgramPageContent(i18n.language))
                setProductBannersData(await CmsService.getProgramBanners(i18n.language))
                setQuestionnaireData(await CmsService.getQuestionnaires(i18n.language))
                setLocaleData(await CmsService.getLocales())

                setIsLoading(false);
            }catch (e){
                console.log("error loading cms context")
                setLandingData({
                    error: e?.code,
                    message: e?.message,
                })
                setPickProgramData({
                    error: e?.code,
                    message: e?.message,
                })
                setProductBannersData({
                    error: e?.code,
                    message: e?.message,
                })
                setQuestionnaireData({
                    error: e?.code,
                    message: e?.message,
                })
                setLocaleData({
                    error: e?.code,
                    message: e?.message,
                })
                setIsLoading(false);
            }
        }
        timeoutId = setTimeout(fetchCms, 0);

        return () => {
            clearTimeout(timeoutId);
        };
    },[]) //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <CmsContext.Provider value={{
            renderingType,
            landingRenderingType,
            landingData,
            pickProgramData,
            questionnaireData,
            productBannersData,
            localeData
        }}>
            {isLoading ?
                <Loader />
                :
                children
            }
        </CmsContext.Provider>
    )
}

export const useCms = () => useContext(CmsContext);